import React, { Component } from "react";
import AppRoutes from "../config/AppRoutes";
import { withRouterUtilities } from "../util/withRouterUtilities";
import CenteredPaper from "../layouts/CenteredPaper";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { pascalCase } from "change-case";
import ChoiceButtons from "../molecules/ChoiceButtons";
import UswfList from "../molecules/UswfList";
import Titles from "../molecules/Titles";
import Custom404Page from "./Custom404Page";
import ILearn from "../molecules/ILearn";

class DynamicContentPage extends Component {
  render() {
    const pathname = this.props.location.pathname;
    const matchingAppRoute = Object.entries(AppRoutes).find(
      ([_, path]) => path.toLowerCase() === pathname.toLowerCase()
    );
    if (!matchingAppRoute) return <Custom404Page />;

    const appRouteKey = matchingAppRoute[0];
    const pascalCaseKey = pascalCase(appRouteKey);

    const content = contentMap[pascalCaseKey];
    const navigationsAway = customNavigationMap[pascalCaseKey];
    if (!content || !navigationsAway) return <Custom404Page />;

    return (
      <div className="page-wrapper">
        <ILearn content={content}>
          <CenteredPaper>
            <Titles content={content} />
            <UswfList content={content} />

            <ChoiceButtons
              content={content}
              navigationsAway={navigationsAway}
              navigate={this.props.navigate}
            />
          </CenteredPaper>
        </ILearn>
      </div>
    );
  }
}

export default withRouterUtilities(DynamicContentPage);
